export default __webpack_public_path__ + "static/media/bg_light_grey_big.a8c4c627.svg";